import * as Styles from '../../../../../SharedModules/StyleConstant/StyleConstant';
import {
  amountComparator,
  cellRenderer,
} from '../../../../../SharedModules/utilities/utilities';

export const getReferenceValue = (data, value) => {
  if (value && data && data.length > 0) {
    const index = data.findIndex(
      (item) => item && item.codeValueID && item.codeValueID.codeValue === value
    );
    if (index !== -1) {
      return data[index].shortDescription;
    }
    return null;
  }
  return null;
};
export const multipleClaimsHead = [
  // {
  //   headerName: 'selected',
  //   field: 'action',
  //   maxWidth: 130,
  //   minWidth: Styles.Width_120,
  //   checkboxSelection: true, // For rows checkbox
  //   headerCheckboxSelection: true, // For header check box
  //   cellStyle: { borderRightColor: Styles.BorderColor },
  //   wrapHeaderText: true,
  //   autoHeaderHeight: true,
  //   filter: false,
  //   sortable: false,
  //   editable: false,
  //   suppressMenu: false,
  // },
  {
    headerName: 'Original Units',
    field: 'origNumOfUnits',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: 120,
    exportZeroesFour: true,
    dataAlignRight: true,
    isTextColorRed: true,
    excelAlignment: 'right',
    comparator: amountComparator,
    printPrefixValue: '',
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },

    custClass: 'tbill-rate-editable-input',
    cellStyle: { textAlign: 'right', borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Number of Units',
    field: 'numOfUnits',
    editable: false,
    suppressMenu: false,
    sortable: true,
    exportZeroesFour: true,
    dataAlignRight: true,
    excelAlignment: 'right',
    cellRenderer: 'GenericCodeTextBox',
    comparator: amountComparator,
    printPrefixValue: '',
    // cellRenderer: 'GenericCodeTextBox',
    minWidth: Styles.Width_100,
    isTextColorRed: true,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },

    custClass: 'tbill-rate-editable-input',
    cellStyle: { textAlign: 'right', borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'HCPCS',
    field: 'hcpcsUnits',
    editable: false,
    suppressMenu: false,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    maxLength: Styles.Length_255,
    comparator: amountComparator,
    printPrefixValue: '',
    exportZeroesFour: true,
    dataAlignRight: true,
    isTextColorRed: true,
    excelAlignment: 'right',
    minWidth: 120,
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },

    custClass: 'tbill-rate-editable-input',
    cellStyle: { textAlign: 'right', borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Provider ID Type',
    field: 'providerIdTypeVal',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_120,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },

    custClass: 'tbill-rate-editable-input',
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Provider Id',
    field: 'providerId',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_135,
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },

    custClass: 'tbill-rate-editable-input',
    cellStyle: {
      textAlign: 'right',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Category',
    field: 'computedCategoryCd',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_130,
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },

    custClass: 'tbill-rate-editable-input',
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
